import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { ActionIcon, Group, isLightColor, Paper, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

import { useCurrentWorkspace } from "@/api/resources/workspaces/hooks";
import { SYSTEM_COLORS } from "@/configs/colorScheme";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useNavigation } from "@/hooks/useNavigation";
import { useRoles } from "@/hooks/useRoles";
import { getDateDaysDifferenceToNow } from "@/utils/dates";
import Icon from "@/utils/icons";

export const TrialBanner = () => {
  const { t } = useTranslation();
  const { isMobile } = useIsMobile();
  const { canEdit: isGlobalAdmin } = useRoles();
  const { goToEndOfTrial } = useNavigation();
  const { data: currentWorkspace } = useCurrentWorkspace();

  const trialEndDate = currentWorkspace?.trial_end_date;
  const isOnTrial = Boolean(trialEndDate);
  const daysLeft = trialEndDate ? Math.max(0, getDateDaysDifferenceToNow(trialEndDate)) : -1;

  useEffect(() => {
    if (currentWorkspace && daysLeft === 0 && !isGlobalAdmin()) {
      goToEndOfTrial();
    }
  }, [currentWorkspace, daysLeft, goToEndOfTrial, isGlobalAdmin]);

  const [opened, { close }] = useDisclosure(true);
  if (!opened || !isOnTrial) return null;

  return (
    <Paper bd={`1px solid ${SYSTEM_COLORS.warning}`} bg="transparent" py={isMobile ? 3 : 4} px="md" mr="md">
      <Group wrap="nowrap" justify="space-between">
        <Icon.WARNING size={18} color={SYSTEM_COLORS.warning} />
        <Text size={isMobile ? "xs" : undefined} c={isLightColor(SYSTEM_COLORS.primary) ? "black" : "white"}>
          {t("trial.banner", { days: Math.round(daysLeft) })}
        </Text>

        <ActionIcon onClick={close}>
          <Icon.CLEAR color={SYSTEM_COLORS.default} />
        </ActionIcon>
      </Group>
    </Paper>
  );
};

export default TrialBanner;
